import { render, staticRenderFns } from "./clubCardSkeleton.vue?vue&type=template&id=509867fe&"
import script from "./clubCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./clubCardSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports